angular.module('lf.common')

.factory('lfFocus', function ($rootScope, $timeout) {
  return function (name) {
    $timeout(function (){
      $rootScope.$broadcast('focusOn', name);
    });
  }
});
